import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind CSS class names intelligently.
 *
 * Combines `clsx` (conditional classes) with `tailwind-merge`
 * (deduplicates and resolves conflicting Tailwind utilities).
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-accent text-white', className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
